export default __webpack_public_path__ + "static/media/carousel3.f737dc84.jpg";